import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const communicationLogService = {
    getAll,
};

const MODULE = {
    COMMUNICATION_LOG: 'communication-logs',
};

const API_URL = API.BASE_URL_API + '/v1';

export function getAll(filter) {
    const request = {
        params: {
            user: filter?.user,
            method: filter?.method,
            page: filter?.pageNumber,
            size: filter?.pageSize,
        },
    };

    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`;
            request.params[searchParam] = word;
        }
    });

    return apiHelper(API_URL).get(`/${MODULE.COMMUNICATION_LOG}`, request);
}